import {
  DEFAULT_PLAYER_POSITION_STALE_MS,
  isPlayerPositionMeasurementStale
} from '@lucimark/shared/helpers/playerPositionStaleness'

/**
 * Status-overlay GPS line for CurrentState.
 * Keep labels short — the panel is ~200–280px wide.
 */
export function resolveGpsStatusOverlayLine(params: {
  running: boolean
  errorMessage?: string | null
  positionDms?: string | null
  positionTimestampMs?: number | null
  nowMs?: number
  staleAfterMs?: number
}): string {
  const nowMs = params.nowMs ?? Date.now()
  const staleAfterMs = params.staleAfterMs ?? DEFAULT_PLAYER_POSITION_STALE_MS
  const stale = params.positionTimestampMs != null
    && isPlayerPositionMeasurementStale({ timestamp: params.positionTimestampMs }, nowMs, staleAfterMs)
  const staleSuffix = stale ? ' (desat.)' : ''

  if (params.running) {
    const dms = params.positionDms?.trim()
    if (dms) {
      return `${dms}${staleSuffix}`
    }
    return 'aguardando...'
  }
  const err = params.errorMessage?.trim()
  if (err) {
    return err
  }
  const dms = params.positionDms?.trim()
  if (dms) {
    return `${dms}${staleSuffix}`
  }
  return 'desativado'
}
